<template>
   <span v-if="isOwner && hasValue && isPrivate">
     <span v-b-tooltip.hover
           title="This data is set by you as Private and is not accessible to other Affiliates"
     >
          <font-awesome-icon :icon="['fas', 'lock']" size="sm"/>
     </span>
   </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    affiliateId: String,
    address: Object,
  },
  computed: {
    ...mapGetters({
      authed: 'auth/isAuthenticated',
      user: 'auth/user',
    }),
    hasValue() {
      return !!this.address ?? null;
    },
    isOwner() {
      return this.authed && this.user.id === this.affiliateId;
    },
    isPrivate() {
      return this.address.visibility === 'private' ?? null;
    },
  },
};
</script>
